
export default () => ({
  showUserForm: false,
  userForm: {
    fullname: null,
    phone: null,
    email: null
  },
  userFormErrors: [],
  showAgencyForm: false,
  agencyForm: {
    message: null
  },
  agencyFormErrors: [],
})
